import React, { useState } from "react";
import { Star, X, Loader2, Send } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL || "";
const NOTAS = Array.from({ length: 11 }, (_, n) => n);

// verde no topo, amarelo no meio, vermelho embaixo — o lojista entende a
// escala sem ler nada
const corNota = (n) =>
  n <= 3 ? "#EF4444" : n <= 6 ? "#F97316" : n <= 8 ? "#EAB308" : "#22C55E";

/** Avaliacao mensal do lojista (dia 01 ao 05). Some assim que ele responde. */
export default function AvaliacaoMensal({ perguntas, onClose, onEnviado }) {
  const [notas, setNotas] = useState({});
  const [comentario, setComentario] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [pronto, setPronto] = useState(false);

  const completo = perguntas.every((q) => notas[q.k] != null);

  const enviar = async () => {
    setErro("");
    if (!completo) { setErro("Responda as 4 perguntas — leva 20 segundos 🙂"); return; }
    setEnviando(true);
    try {
      const r = await fetch(`${API}/api/avaliacao`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ ...notas, comentario }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || d.ok === false) { setErro(d.erro || d.detail || "Não foi possível enviar."); return; }
      setPronto(true);
      onEnviado?.();
      setTimeout(onClose, 1800);
    } catch (_) { setErro("Falha de conexão — tente de novo."); }
    finally { setEnviando(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-lg max-h-[92vh] overflow-y-auto rounded-2xl bg-card border border-border p-5 shadow-2xl">
        {pronto ? (
          <div className="py-10 text-center">
            <div className="w-14 h-14 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-3">
              <Star className="w-7 h-7 text-green-500" />
            </div>
            <h3 className="text-lg font-bold text-foreground">Obrigado! 🧡</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Sua avaliação chega direto no nosso time de Sucesso do Cliente.
            </p>
          </div>
        ) : (
          <>
            <div className="flex items-start justify-between gap-3 mb-4">
              <div>
                <h3 className="text-lg font-bold text-foreground flex items-center gap-2">
                  <Star className="w-5 h-5 text-orange-500" /> Como está sendo o Núcleo pra você?
                </h3>
                <p className="text-xs text-muted-foreground mt-0.5">
                  Leva 20 segundos e ajuda a gente a melhorar o que importa pra sua loja.
                </p>
              </div>
              <button onClick={onClose} className="p-1.5 rounded-lg text-muted-foreground hover:bg-muted">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              {perguntas.map((q) => (
                <div key={q.k}>
                  <p className="text-sm text-foreground mb-1.5">{q.p}</p>
                  <div className="grid grid-cols-11 gap-1">
                    {NOTAS.map((n) => {
                      const ativo = notas[q.k] === n;
                      return (
                        <button key={n} onClick={() => setNotas({ ...notas, [q.k]: n })}
                          className={`py-2 rounded-lg text-sm font-bold border-2 transition-all ${
                            ativo ? "text-white scale-105" : "border-border text-muted-foreground hover:border-foreground/40"}`}
                          style={ativo ? { backgroundColor: corNota(n), borderColor: corNota(n) }
                                       : { borderColor: `${corNota(n)}55`, color: corNota(n) }}>
                          {n}
                        </button>
                      );
                    })}
                  </div>
                  <div className="flex justify-between mt-0.5 text-[10px] text-muted-foreground">
                    <span>0 · {q.min}</span><span>{q.max} · 10</span>
                  </div>
                </div>
              ))}

              <div>
                <p className="text-sm text-foreground mb-1.5">
                  Quer contar mais alguma coisa? <span className="text-muted-foreground">(opcional)</span>
                </p>
                <textarea rows={3} value={comentario} onChange={(e) => setComentario(e.target.value)}
                  placeholder="o que está bom, o que atrapalha, o que você gostaria que o Núcleo tivesse..."
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground text-sm resize-none outline-none focus:border-orange-500" />
              </div>

              {erro && <p className="text-sm font-semibold text-red-500">{erro}</p>}

              <button onClick={enviar} disabled={enviando}
                className="w-full py-2.5 rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-bold flex items-center justify-center gap-2 disabled:opacity-60">
                {enviando ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                Enviar avaliação
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
